import isNil from 'lodash/isNil';
import { LimitsAreaIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit, LimitSummaryUsage } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SquareKmLimitSummary({
  className,
  limit,
  schema,
  usage
}) {
  let available = limit === 0 ? 0 : Math.round(limit - usage);
  if (available < 0) available = 0;
  return !isNil(limit) ? /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [/*#__PURE__*/_jsx(LimitSummaryIcon, {
      as: LimitsAreaIcon
    }), ' ', /*#__PURE__*/_jsxs(LimitSummaryLimit, {
      children: [limit, " km", /*#__PURE__*/_jsx("sup", {
        children: "2"
      })]
    }), ' ', typeof usage === 'number' && /*#__PURE__*/_jsxs(LimitSummaryUsage, {
      danger: available < 20,
      children: [available, " km", /*#__PURE__*/_jsx("sup", {
        children: "2"
      }), " available"]
    })]
  }) : null;
}